import React from "react";
import { useSelector } from "react-redux";
import LandingHeader from "../components/landing/LandingHeader";
import LandingFooter from "../components/landing/LandingFooter";

const CookiePolicy = () => {
  const translation = useSelector((state) => state.translation);

  return (
    <div className="privacy-page">
      <LandingHeader />
      <main className="privacy-main">
        <div className="policy-hero-wrap">
          <div className="privacy-container content-area-container">
            <div className="privacy-header">
              <h1>{translation.cookie_title || "Cookie Policy"}</h1>
              <p className="privacy-date">{translation.cookie_effective_date || "Effective Date: January 21, 2026"}</p>
            </div>
          </div>
        </div>
        <div className="privacy-container">

          <p className="privacy-intro">
            {translation.cookie_intro ||
              "This Cookie Policy explains how esyncing uses cookies and similar technologies when you visit or use our website and platform."}
          </p>

          <section className="privacy-section">
            <h2>{translation.cookie_section1_title || "1. What Are Cookies?"}</h2>
            <p>
              {translation.cookie_section1_text ||
                "Cookies are small text files stored on your device that help websites function properly and improve user experience."}
            </p>
          </section>

          <section className="privacy-section">
            <h2>{translation.cookie_section2_title || "2. Types of Cookies We Use"}</h2>
            <div className="privacy-subsection">
              <h3>{translation.cookie_section2a_title || "a) Essential Cookies"}</h3>
              <p>{translation.cookie_section2a_text || "These cookies are required to:"}</p>
              <ul>
                <li>{translation.cookie_section2a_item1 || "Enable core website and platform functionality"}</li>
                <li>{translation.cookie_section2a_item2 || "Maintain secure user sessions"}</li>
                <li>{translation.cookie_section2a_item3 || "Allow basic navigation"}</li>
              </ul>
              <p>{translation.cookie_section2a_footer || "Without these cookies, the platform may not function correctly."}</p>
            </div>
            <div className="privacy-subsection">
              <h3>{translation.cookie_section2b_title || "b) Functional Cookies"}</h3>
              <p>{translation.cookie_section2b_text || "These cookies help:"}</p>
              <ul>
                <li>{translation.cookie_section2b_item1 || "Remember user preferences"}</li>
                <li>{translation.cookie_section2b_item2 || "Improve usability"}</li>
                <li>{translation.cookie_section2b_item3 || "Maintain language or region settings"}</li>
              </ul>
            </div>
            <div className="privacy-subsection">
              <h3>{translation.cookie_section2c_title || "c) Analytics Cookies"}</h3>
              <p>{translation.cookie_section2c_text || "Analytics cookies help us understand:"}</p>
              <ul>
                <li>{translation.cookie_section2c_item1 || "How users interact with the platform"}</li>
                <li>{translation.cookie_section2c_item2 || "Which features are used most"}</li>
                <li>{translation.cookie_section2c_item3 || "Overall performance and usage trends"}</li>
              </ul>
              <p>{translation.cookie_section2c_footer || "This data is aggregated and does not directly identify individuals."}</p>
            </div>
          </section>

          <section className="privacy-section">
            <h2>{translation.cookie_section3_title || "3. How We Use Cookies"}</h2>
            <p>{translation.cookie_section3_text || "We use cookies to:"}</p>
            <ul>
              <li>{translation.cookie_section3_item1 || "Keep users logged in"}</li>
              <li>{translation.cookie_section3_item2 || "Improve platform performance"}</li>
              <li>{translation.cookie_section3_item3 || "Enhance security and reliability"}</li>
              <li>{translation.cookie_section3_item4 || "Understand user behavior for product improvement"}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{translation.cookie_section4_title || "4. Third-Party Cookies"}</h2>
            <p>
              {translation.cookie_section4_text ||
                "Some cookies may be placed by third-party services such as analytics providers. These third parties may collect data according to their own privacy policies."}
            </p>
          </section>

          <section className="privacy-section">
            <h2>{translation.cookie_section5_title || "5. Managing Cookies"}</h2>
            <p>{translation.cookie_section5_text || "You can control or delete cookies through your browser settings."}</p>
            <p>{translation.cookie_section5_subtitle || "Please note:"}</p>
            <ul>
              <li>{translation.cookie_section5_item1 || "Disabling cookies may affect platform functionality"}</li>
              <li>{translation.cookie_section5_item2 || "Some features may not work as intended"}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{translation.cookie_section6_title || "6. Changes to This Policy"}</h2>
            <p>
              {translation.cookie_section6_text ||
                "We may update this Cookie Policy from time to time. Updates will be posted on this page with a revised effective date."}
            </p>
          </section>

          <section className="privacy-section">
            <h2>{translation.cookie_section7_title || "7. Contact Us"}</h2>
            <p>{translation.cookie_section7_text || "If you have questions about our use of cookies:"}</p>
            <div className="privacy-contact">
              <div className="contact-card">
                <h4>{translation.cookie_section7_card_title || "Email"}</h4>
                <p>{translation.cookie_section7_card_email || "privacy@esyncing.com"}</p>
                <span>{translation.cookie_section7_card_note || "You can also reach our support team through the platform's contact page."}</span>
              </div>
            </div>
          </section>

          <p className="privacy-updated">
            {translation.cookie_last_updated || "This Cookie Policy was last updated on January 21, 2026."}
          </p>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
};

export default CookiePolicy;
